const filters = {
  "Rural Development Drivers (RDD)": [
    "Sustainable multimodal mobility",
    "Energy transition and climate neutrality",
    "Sustainable agrifood systems and ecosystem management",
    "Nature-based and cultural tourism",
    "Culture and cultural innovation",
    "Local services, health and wellbeing",
  ],
  // "Climate Change Mitigation": [
  //   "Linked to climate neutrality goals",
  //   "Mitigates/reduces greenhouse gas emissions",
  //   "Removes greenhouse gases from atmosphere",
  //   "Improves GHG measurement/monitoring",
  //   "Participates in EU carbon market",
  //   "Raises awareness and improves education",
  //   "Addresses consumption and carbon lifestyles"
  // ],
  "Cross Cutting Priorities":[
    "Climate change adaptation",
    "Climate change mitigation",
    "Protecting biodiversity",
    "Social justice and inclusion",
  ],
  "Location(Country)": [
    "Albania",
    "Austria",
    "Belgium",
    "Bosnia and Herzegovina",
    "Brazil",
    "Bulgaria",
    "Costa Rica",
    "Croatia",
    "Denmark",
    "Egypt",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Greenland",
    "Hungary",
    "Ireland",
    "Israel",
    "Italy",
    "Kenya",
    "Kosovo",
    "Latvia",
    "Lithuania",
    "Macedonia",
    "Montenegro",
    "Morocco",
    "Netherlands",
    "Northern Ireland",
    "Norway",
    "Palestine",
    "Poland",
    "Portugal",
    "Romania",
    "Scotland",
    "Serbia",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden",
    "Switzerland",
    "Tunisia",
    "Turkey",
    "Ukraine",
    "United Kingdom",
    "USA",
  ],
};

const customFieldNames = {
  aims: "Aim",
  beneficiaries: "Beneficiaries",
  beneficiaries_details: "Beneficiaries Details",
  challenges_details_1: "Poverty and exclusion",
  challenges_details_2: "Services and infrastructure",
  challenges_details_3: "Low education and skills",
  challenges_details_4: "Digital divide",
  challenges_details_5: "Climate change and natural disasters",
  challenges_details_6: "Ageing",
  challenges_details_7: "Gender gap",
  challenges_details_8: "Over tourism and uneven development",
  challenges_details_9: "Depopulation",
  challenges_details_10: "Unemployment",
  challenges_details_11: "Other - Description",
  challenges_details_11_description: "Other",
  change: "Change",
  change_details: "Change Details",
  comments: "Comments",
  continuation: "Continuation",
  continuation_details_no: "Continuation Details No",
  continuation_details_yes: "Continuation Details Yes",
  gender: "Gender",
  gender_detail_1: "Woman or group of women",
  gender_detail_2: "Transgender person or group of transgender persons",
  gender_detail_3: "Man or group of men",
  gender_detail_4: "People of different genders led by a woman",
  gender_detail_5: "People of different genders led by atransgender person",
  gender_detail_6: "People of different genders led by a man",
  gender_detail_7: "Other",
  geographical_features_1: "Island",
  geographical_features_2: "Archipelago",
  geographical_features_3: "Coastal area",
  geographical_features_4: "Mountain area",
  geographical_features_5: "Hilly",
  geographical_features_6: "Flat",
  geographical_features_7: "River",
  geographical_features_8: "Flood plain",
  geospatial_data: "Geospatial Data",
  geospatial_data_details: "Geospatial Data Details",
  impact: "Impact",
  location_country: "Location Country",
  location_region: "Location Region",
  location_town: "Location Town",
  organisation: "Organisation",
  organisation_country: "Organisation Country",
  organisation_details: "Organisation Details",
  organisation_region: "Organisation Region",
  organisation_town: "Organisation Town",
  organisation_type: "Organisation Type",
  organization_other_1: "Organization Other 1",
  organization_other_2: "Organization Other 2",
  organization_other_3: "Organization Other 3",
  organization_other_4: "Organization Other 4",
  organization_other_5: "Organization Other 5",
  organization_other_6: "Organization Other 6",
  organization_other_7: "Organization Other 7",
  organization_other_8: "Organization Other 8",
  organization_other_9: "Organization Other 9",
  organization_other_10: "Organization Other 10",
  relationship: "Relationship",
  relationship_details: "Relationship Details",
  story: "Story",
  territorial_scale: "Territorial Scale",
  title_english: "Title (English)",
  title_local: "Title (Local)",
  website: "Website",
  rdd_1: "Primary RDD",
  rdd_2: "Secondary RDD",
  rdd_3: "Tertiary RDD",
  competencies_required: "Areas of competency",
};
const fieldCategories = {
  GeneralInformation: [
    "organisation",
    "organisation_type",
    "aims",
    "impact",
    "beneficiaries",
    "beneficiaries_details",
    "story",
    "relationship",
    "relationship_details",
    "title_english",
    "title_local",
    "website",
  ],
  Challenges: [
    //"challenges_1",
    "challenges_details_1",
    //"challenges_2",
    "challenges_details_2",
    //"challenges_3",
    "challenges_details_3",
    //"challenges_4",
    "challenges_details_4",
    //"challenges_5",
    "challenges_details_5",
    //"challenges_6",
    "challenges_details_6",
    //"challenges_7",
    "challenges_details_7",
    //"challenges_8",
    "challenges_details_8",
    //"challenges_9",
    "challenges_details_9",
    //"challenges_10",
    "challenges_details_10",
    //"challenges_11",
    "challenges_details_11_description",
    "challenges_details_11",
  ],
  Gender: [
    "gender",
    "gender_detail_1",
    "gender_detail_2",
    "gender_detail_3",
    "gender_detail_4",
    "gender_detail_5",
    "gender_detail_6",
    "gender_detail_7",
  ],
  ContinuationAndChange: [
    "change",
    "change_details",
    "continuation",
    "continuation_details_no",
    "continuation_details_yes",
    "comments",
  ],
  Location: [
    "location_country",
    "location_region",
    "location_town",
    "geospatial_data",
    "geospatial_data_details",
    "territorial_scale",
  ],
  GeographicalFeatures: [
    "geographical_features_1",
    "geographical_features_2",
    "geographical_features_3",
    "geographical_features_4",
    "geographical_features_5",
    "geographical_features_6",
    "geographical_features_7",
    "geographical_features_8",
  ],
  RuralDevelopmentDrivers: ["rdd_1", "rdd_2", "rdd_3"],
  SustainableAgrifoodSystemsAndCcosystemManagement: [
    "agrifood_and_ecosystem_1",
    "agrifood_and_ecosystem_2",
    "agrifood_and_ecosystem_3",
    "agrifood_and_ecosystem_4",
    "agrifood_and_ecosystem_5",
    "agrifood_and_ecosystem_6",
  ],
  CultureAndCulturalInnovation: [
    "culture_innovation_1",
    "culture_innovation_2",
    "culture_innovation_3",
    "culture_innovation_4",
    "culture_innovation_5",
  ],
  EnergyTransitionAndClimateNeutrality: [
    "energy_and_climate_1",
    "energy_and_climate_2",
    "energy_and_climate_3",
    "energy_and_climate_4",
    "energy_and_climate_5",
    "energy_and_climate_6",
  ],
  NatureBasedAndCulturalTourism: [
    "nature_and_cultural_tourism_1",
    "nature_and_cultural_tourism_2",
    "nature_and_cultural_tourism_3",
    "nature_and_cultural_tourism_4",
  ],
  LocalServicesHealthAndWellbeing: [
    "services_and_health_1",
    "services_and_health_2",
    "services_and_health_3",
    "services_and_health_4",
    "services_and_health_5",
    "services_and_health_6",
    "services_and_health_7",
    "services_and_health_8",
    "services_and_health_9",
  ],
  SustainableMultimodalMobility: [
    "sustainable_mobility_1",
    "sustainable_mobility_2",
    "sustainable_mobility_3",
    "sustainable_mobility_4",
    "sustainable_mobility_5",
    "sustainable_mobility_6",
  ],
  DigitalNovelty: [
    "digital_novelty",
    "digital_novelty_description",
    "digital_novelty_maturity",
    "digital_novelty_api",
    "digital_novelty_api_link",
    "digital_novelty_1",
    "digital_novelty_1_description",
    "digital_novelty_2",
    "digital_novelty_2_description",
    "digital_novelty_3",
    "digital_novelty_3_description",
    "digital_novelty_4",
    "digital_novelty_4_description",
  ],
  TechnicalInnovation: [
    "technical_innovation_1",
    "technical_innovation_1_description",
    "technical_innovation_2",
    "technical_innovation_2_description",
    "technical_innovation_3",
    "technical_innovation_3_description",
  ],
  SocialInnovation: [
    "social_innovation_1",
    "social_innovation_1_details",
    "social_innovation_2",
    "social_innovation_2_details",
    "social_innovation_3",
    "social_innovation_3_details",
    "social_innovation_4",
    "social_innovation_4_details",
    "social_innovation_5",
    "social_innovation_5_details",
    "social_innovation_6",
    "social_innovation_6_details",
    "social_innovation_7",
    "social_innovation_7_details",
    "social_innovation_8",
    "social_innovation_8_details",
    "social_innovation_9",
    "social_innovation_9_details",
  ],
  BusinessInnovation: [
    "business_innovation_1",
    "business_innovation_1_description",
    "business_innovation_2",
    "business_innovation_2_description",
    "business_innovation_3",
    "business_innovation_3_description",
    "business_innovation_4",
    "business_innovation_4_description",
  ],
  SocialAndEnviromentalChallangesAndGoals: [
    "social_and_environmental_challenges_1",
    "social_and_environmental_challenges_2",
    "social_and_environmental_challenges_3",
    "social_and_environmental_challenges_4",
  ],
  ClimateChangeAdaptation: [
    "climate_changing_1",
    "climate_changing_1_details",
    "climate_changing_2",
    "climate_changing_2_details",
    "climate_changing_3",
    "climate_changing_3_details",
  ],
  ClimateChangeMitigation: [
    "climate_changing_causes_1",
    "climate_changing_causes_1_details",
    "climate_changing_causes_2",
    "climate_changing_causes_2_details",
    "climate_changing_causes_3",
    "climate_changing_causes_3_details",
    "climate_changing_causes_4",
    "climate_changing_causes_4_details",
    "climate_changing_causes_5",
    "climate_changing_causes_5_details",
    "climate_changing_causes_6",
    "climate_changing_causes_6_details",
    "climate_changing_causes_7",
    "climate_changing_causes_7_details",
  ],
  Biodiversity: [
    "biodiversity_1",
    "biodiversity_1_details",
    "biodiversity_2",
    "biodiversity_2_details",
    "biodiversity_3",
    "biodiversity_3_details",
    "biodiversity_4",
    "biodiversity_4_details",
    "biodiversity_5",
    "biodiversity_5_details",
    "biodiversity_6",
    "biodiversity_6_details",
    "biodiversity_7",
    "biodiversity_7_details",
  ],
  SocialJusticeAndInclusion: [
    "participatory_process_1",
    "participatory_process_1_details",
    "participatory_process_2",
    "participatory_process_2_details",
    "participatory_process_3",
    "participatory_process_3_details",
    "participatory_process_4",
    "participatory_process_4_details",
    "participatory_process_5",
    "participatory_process_5_details",
    "participatory_process_6",
    "participatory_process_6_details",
  ],
  AreasOfCompetency: ["competencies_required"],
  DigitalAndTechnologicalCompetencies: [
    "competencies_digital_and_technological_1",
    "competencies_digital_and_technological_1_level",
    "competencies_digital_and_technological_1_required",
    "competencies_digital_and_technological_2",
    "competencies_digital_and_technological_2_level",
    "competencies_digital_and_technological_2_required",
    "competencies_digital_and_technological_3",
    "competencies_digital_and_technological_3_level",
    "competencies_digital_and_technological_3_required",
    "competencies_digital_and_technological_4",
    "competencies_digital_and_technological_4_level",
    "competencies_digital_and_technological_4_required",
    "competencies_digital_and_technological_5",
    "competencies_digital_and_technological_5_level",
    "competencies_digital_and_technological_5_required",
    "competencies_digital_and_technological_6",
    "competencies_digital_and_technological_6_level",
    "competencies_digital_and_technological_6_required",
    "competencies_digital_and_technological_7",
    "competencies_digital_and_technological_7_level",
    "competencies_digital_and_technological_7_required",
  ],
  TechnicalCompetencies: [
    "competencies_technical_1",
    "competencies_technical_1_level",
    "competencies_technical_1_required",
    "competencies_technical_2",
    "competencies_technical_2_level",
    "competencies_technical_2_required",
    "competencies_technical_3",
    "competencies_technical_3_level",
    "competencies_technical_3_required",
    "competencies_technical_4",
    "competencies_technical_4_level",
    "competencies_technical_4_required",
    "competencies_technical_5",
    "competencies_technical_5_level",
    "competencies_technical_5_required",
    "competencies_technical_6",
    "competencies_technical_6_level",
    "competencies_technical_6_required",
    "competencies_technical_7",
    "competencies_technical_7_level",
    "competencies_technical_7_required",
  ],
  SocialCompetencies: [
    "competencies_social_1",
    "competencies_social_1_level",
    "competencies_social_1_required",
    "competencies_social_2",
    "competencies_social_2_level",
    "competencies_social_2_required",
    "competencies_social_3",
    "competencies_social_3_level",
    "competencies_social_3_required",
    "competencies_social_4",
    "competencies_social_4_level",
    "competencies_social_4_required",
    "competencies_social_5",
    "competencies_social_5_level",
    "competencies_social_5_required",
  ],
  OrganisationalCompetencies: [
    "competencies_organisational_1",
    "competencies_organisational_1_level",
    "competencies_organisational_1_required",
    "competencies_organisational_2",
    "competencies_organisational_2_level",
    "competencies_organisational_2_required",
    "competencies_organisational_3",
    "competencies_organisational_3_level",
    "competencies_organisational_3_required",
    "competencies_organisational_4",
    "competencies_organisational_4_level",
    "competencies_organisational_4_required",
  ],
  GovernanceCompetencies: [
    "competencies_governance_1",
    "competencies_governance_1_level",
    "competencies_governance_1_required",
    "competencies_governance_2",
    "competencies_governance_2_level",
    "competencies_governance_2_required",
    "competencies_governance_3",
    "competencies_governance_3_level",
    "competencies_governance_3_required",
    "competencies_governance_4",
    "competencies_governance_4_level",
    "competencies_governance_4_required",
  ],
};
export { filters, customFieldNames, fieldCategories };
